
webpack.register(
    'modules/search/search',
    function() {
        return import('modules/search/search');
    },
    true
);